import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { Layout } from './components/Layout';
import { PrivateRoute } from './components/PrivateRoute';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { Projetos } from './pages/Projetos';
import { ProjetoDetalhe } from './pages/ProjetoDetalhe';
import { Tarefas } from './pages/Tarefas';
import { Equipe } from './pages/Equipe';
import { Convites } from './pages/Convites';
import { Historico } from './pages/Historico';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route
            element={
              <PrivateRoute>
                <Layout />
              </PrivateRoute>
            }
          >
            <Route path="/" element={<Dashboard />} />
            <Route path="/projetos" element={<Projetos />} />
            <Route path="/projetos/:projetoId" element={<ProjetoDetalhe />} />
            <Route path="/projetos/:projetoId/etapas/:etapaId/tarefas" element={<Tarefas />} />
            <Route path="/convites" element={<Convites />} />
            <Route path="/equipe" element={<Equipe />} />
            <Route path="/historico" element={<Historico />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
